import styled, { css } from 'styled-components'
import theme from 'live/services/theme'

export const SpanContainerStyled = styled.div`
    .modal-dialog {
        height: calc(${({height}) => height || '100%'} - 40px);
        margin: 20px auto !important;
        
        .modal-content {
            height: 100%;

            .modal-body { 
                height: calc(100% - 109px);
            }
        }
    }
`

export const ModalBody = styled.div`
    display: flex;
    padding: 0px;
    height: 100%;

    .fa-spin {
        margin-left: 10px;
        line-height: unset;
    }
`

export const FooterActions = styled.div`
    display: flex;
    align-items: center;
    .err-info {
        width: 100%;
        text-align: right;
        color: #ff2424;
        display: inline-block;
        margin-left: 10px;
    }
    .mode-selector {
        position: absolute;
        right: 25px;
    }
`

export const Wrapper = styled.div`
    width: 100%;
    flex-flow: column;
    display: flex;
    height: 100%;
    overflow-y: auto;
    justify-content: center;

    border-radius: 3px;
    color: var(--text-color);
    font-family: var(--font-semibold);
    border: 1px solid var(--gray-300);

    :last-child {
        > div {
            .input {
                box-shadow: none !important;
                border: none !important;
                border: 1px solid var(--gray-300) !important;
            }
        } 
    }
    
    .calendar-content {
        .calendars-container {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            margin-top: 12px;
            
            .calendar {
                border: 1px solid var(--gray-300);
            }

            .calendar-date > table {
                width: 320px;
                background-color: var(--gray-0);
            }
            .time-input-container-wrapper {
                display: flex;
                justify-content: space-evenly;
                width: 100%;
                padding: 12px 18px;
                align-items: center;
            }
            .time-input-container {
                input {
                    margin-top:3px;
                }
            }
        }
    }

    .header-dropdown-component {
        margin-top: 2px;
        height: 49px;
        padding: 12px 16px;
        background: var(--gray-200);
        display: flex;
        flex-flow: row;
        justify-content: space-between;

        .header-title {
            font-size: 14px;
            font-weight: 600;
            padding-top: 6px;
            color: var(--text-color);

            .btn.btn-primary {
                background: ${theme['brand-primary']};
            }
        }
    }

    .form-group.timespan-options {
        display: flex;
        flex-flow: nowrap;
        justify-content: flex-start;
        margin: 8px 0px 0px 16px;
        align-items: baseline;

        .radio {
            margin: 0px 8px;
        }

        label {
            white-space: nowrap;
            font-size: 12px;
            color: var(--text-color);
        }
    }

    .filter-dropdown-component {
        display: flex;
        flex-flow: column;
        padding-top: 4px;
        border-bottom: solid 1px var(--gray-400);
        background: var(--gray-200);

        .toggle {
            padding: 0px 98px 0px 0px;
        }

        .operation-selected {
            font-size: 11px;
            margin: 10px 0px 10px 16px;
            font-weight: 600;

            span.label-checkbox {
                margin-left: 8px;
            }
        }

        .search-input {
            margin: 8px 8px 0px 16px;
            display: inline-block;
            width: 63%;
            > div {
                box-shadow: none;
            }
            input {
                box-shadow: none;
                border: solid 1px var(--gray-400);
                padding-bottom: 0px;
                padding-top: 0px;
                height: 34px;
                border-radius: 2px;
            }
        }

        .select-input {
            width: 37%;
            margin-right: 8px;

            .input-group {
                margin-top: 8px;
                width: 100%;
            }

            .form-group,
            li.input {
                margin-bottom: 0px;
            }

            .live-select > .select-input > .has-value > .Select-control .Select-value > .Select-value-label {
                color: var(--text-color);
            }

            .Select-input,
            .Select-placeholder,
            .Select-control {
                height: 32px;
            }
        }

        .search-row {
            display: flex;
            flex-flow: row;
            padding-bottom: 6px;
        }

        .Select-menu .Select-option {
            color: var(--text-color);
            border-top: 1px solid var(--gray-400);
            border-left: 1px solid var(--gray-400);
            border-right: 1px solid var(--gray-400);
            height: 32px;
            
            :last-child {
                border-bottom: 1px solid var(--gray-400);
            }
        }

        .Select-menu {
            ::-webkit-scrollbar {
                width: 8px;
            }

            ::-webkit-scrollbar-track {
                background-color: var(--gray-400);
            }

            ::-webkit-scrollbar-thumb {
                background: ${theme['auxiliar-typography']};
                opacity: 0.5;
                border-radius: 5px;
                width: 8px;
            }

            ::-webkit-scrollbar-thumb:hover {
                background: ${theme['auxiliar-typography']};
                opacity: 1;
            }
        }

        .Select-menu-outer {
            border: none;
            > * {
                border: none;
            }
        }
    }

    .tree-component {
        overflow-y: auto;
        height: 100%;

        > div {
            height: 100%;
        }

        .using-for-model,
        .use-for-model {
            float: right;
            display: none;
            font-size: 11px;
            font-style: normal;
        }

        .opMode,
        .depth-Op-Mode {
            font-family: ${theme['font-regular']};
            font-style: normal;
            font-weight: 600;
            font-size: 11px;
            line-height: 12px;
            color: var(--text-color);
        }

        .depth-Op-Mode {
            color: var(--gray-600);
            margin-left: 8px;
        }

        .ant-tree-node-content-wrapper {
            :hover {
                .use-for-model {
                    display: unset;
                }
            }
        }

        .ant-tree-node-selected {
            .using-for-model {
                display: unset;
            }
            :hover {
                .use-for-model {
                    display: none;
                }
            }
        }

        .tree-line {
            overflow: hidden;
            height: 24px;
        }

        ::-webkit-scrollbar {
            width: 8px;
        }

        ::-webkit-scrollbar-track {
            background-color: #303a33f;
        }

        ::-webkit-scrollbar-thumb {
            background: ${theme['auxiliar-typography']};
            opacity: 0.5;
            border-radius: 5px;
            width: 8px;
        }

        ::-webkit-scrollbar-thumb:hover {
            background: ${theme['auxiliar-typography']};
            opacity: 1;
        }
    }
`
